/** Loading layouts that match the page they stand in for (§4.4 meaningful skeletons). */
import { Skeleton } from '@windrop/ui';

export function PageSkeleton({
  label = 'Loading',
  tiles = 4,
  table = true,
}: {
  label?: string;
  tiles?: number;
  table?: boolean;
}) {
  return (
    <div className="wdc-skeleton-page" aria-busy="true">
      <Skeleton shape="text" width="30%" height={28} label={label} />
      <Skeleton shape="text" width="55%" height={14} />
      {tiles > 0 ? (
        <div className="wdc-stats">
          {Array.from({ length: tiles }, (_, i) => (
            <Skeleton key={i} shape="block" height={108} />
          ))}
        </div>
      ) : null}
      {table ? <Skeleton shape="block" height={280} /> : null}
    </div>
  );
}

export function DetailSkeleton({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="wdc-skeleton-page" aria-busy="true">
      <Skeleton shape="text" width="18%" height={12} label={label} />
      <Skeleton shape="text" width="40%" height={28} />
      <div className="wdc-layout">
        <div className="wd-stack">
          <Skeleton shape="block" height={200} />
          <Skeleton shape="block" height={160} />
        </div>
        <Skeleton shape="block" height={240} />
      </div>
    </div>
  );
}
